import { cloneDeep } from 'lodash'
import React from 'react'
import CapIcon from '../_assets/icons/CapIcon'
import DefenderIcon from '../_assets/icons/DefenderIcon'
import IntuneIcon from '../_assets/icons/IntuneIcon'
import { ReactComponent as ThreatAlertsIcon } from '../_assets/icons/threat-alerts.svg'

export const LANDING_PAGE_PATH = '/secure/security-posture'

const menuConfig = {
  aside: {
    self: {},
    items: [
      {
        title: 'Secure',
        icon: 'secure',
        page: 'secure',
        translate: 'MENU.SECURE',
        visible: true,
        submenu: [
          {
            title: 'Alerts',
            icon: <ThreatAlertsIcon />,
            page: 'secure/alerts',
            translate: 'MENU.THREAT_ALERTS',
            visible: true,
            new: false,
          },
          {
            title: 'Security Posture',
            icon: 'backup',
            page: 'secure/security-posture-menu',
            translate: 'MENU.SECURITY_POSTURE',
            visible: true,
            submenu: [
              {
                title: 'Audit',
                page: 'secure/security-posture',
                translate: 'GENERAL.AUDIT',
                visible: true,
              },
              {
                title: 'Posture Templates',
                page: 'secure/posture-templates',
                translate: 'MENU.POSTURE_TEMPLATES',
                visible: true,
              },
            ],
          },
          {
            title: 'Conditional Access',
            icon: <CapIcon namespace="menu" />,
            page: 'secure/policy-management',
            translate: 'MENU.CONDITIONAL_ACCESS',
            visible: true,
            submenu: [
              {
                title: 'Policies',
                page: 'secure/policy-management/policies',
                translate: 'MENU.POLICY_MANAGEMENT_POLICIES',
                visible: true,
              },
              {
                title: 'Templates',
                page: 'secure/policy-management/templates',
                translate: 'MENU.POLICY_TEMPLATES',
                visible: true,
              },
              {
                title: 'Named Locations',
                page: 'secure/policy-management/named-locations',
                translate: 'MENU.POLICY_MANAGEMENT_NAMED_LOCATIONS',
                visible: true,
              },
            ],
          },
          {
            title: 'Defender',
            icon: <DefenderIcon namespace="menu" />,
            page: 'secure/defender',
            translate: 'MENU.DEFENDER',
            visible: true,
            submenu: [
              {
                title: 'Policies',
                page: 'secure/defender/policies',
                translate: 'MENU.POLICY_MANAGEMENT_POLICIES',
                visible: true,
              },
              {
                title: 'Templates',
                page: 'secure/defender/templates',
                translate: 'MENU.POLICY_TEMPLATES',
                visible: true,
              },
            ],
          },
          {
            title: 'Intune',
            icon: <IntuneIcon namespace="menu" />,
            page: 'secure/intune',
            translate: 'MENU.INTUNE',
            visible: true,
            submenu: [
              {
                title: 'Device Management',
                page: 'secure/intune/device-management',
                translate: 'MENU.DEVICE_MANAGEMENT',
                visible: true,
                submenu: [
                  {
                    title: 'Configuration',
                    page: 'secure/intune/device-management/configuration',
                    translate: 'MENU.CONFIGURATION',
                    visible: true,
                  },
                  {
                    title: 'Configuration',
                    page: 'secure/intune/device-management/configuration/policies',
                    translate: 'MENU.CONFIGURATION',
                    visible: false, // should not be visible - workaround for the subheader title to appear
                  },
                  {
                    title: 'Configuration',
                    page: 'secure/intune/device-management/configuration/templates',
                    translate: 'MENU.CONFIGURATION',
                    visible: false, // should not be visible - workaround for the subheader title to appear
                  },

                  {
                    title: 'Compliance',
                    page: 'secure/intune/device-management/compliance',
                    translate: 'MENU.COMPLIANCE',
                    visible: true,
                  },
                  {
                    title: 'Compliance',
                    page: 'secure/intune/device-management/compliance/policies',
                    translate: 'MENU.COMPLIANCE',
                    visible: false, // should not be visible - workaround for the subheader title to appear
                  },
                  {
                    title: 'Compliance',
                    page: 'secure/intune/device-management/compliance/templates',
                    translate: 'MENU.COMPLIANCE',
                    visible: false, // should not be visible - workaround for the subheader title to appear
                  },
                ],
              },
              {
                title: 'App Management',
                page: 'secure/intune/app-management',
                translate: 'MENU.APP_MANAGEMENT',
                visible: true,
                submenu: [
                  {
                    title: 'Apps',
                    page: 'secure/intune/app-management/apps',
                    translate: 'MENU.APPS',
                    featureFlag: 'intune-mobile-apps',
                    visible: true,
                  },
                  {
                    title: 'Apps',
                    page: 'secure/intune/app-management/apps/list',
                    translate: 'MENU.APPS',
                    visible: false, // should not be visible - workaround for the subheader title to appear
                  },
                  {
                    title: 'Apps',
                    page: 'secure/intune/app-management/apps/templates',
                    translate: 'MENU.APPS',
                    visible: false, // should not be visible - workaround for the subheader title to appear
                  },
                  {
                    title: 'Protection',
                    page: 'secure/intune/app-management/protection',
                    translate: 'MENU.PROTECTION',
                    visible: true,
                  },
                  {
                    title: 'Protection',
                    page: 'secure/intune/app-management/protection/policies',
                    translate: 'MENU.PROTECTION',
                    visible: false, // should not be visible - workaround for the subheader title to appear
                  },
                  {
                    title: 'Protection',
                    page: 'secure/intune/app-management/protection/templates',
                    translate: 'MENU.PROTECTION',
                    visible: false, // should not be visible - workaround for the subheader title to appear
                  },
                  {
                    title: 'Configuration',
                    page: 'secure/intune/app-management/configuration',
                    translate: 'MENU.CONFIGURATION',
                    visible: true,
                  },
                  {
                    title: 'Configuration',
                    page: 'secure/intune/app-management/configuration/policies',
                    translate: 'MENU.CONFIGURATION',
                    visible: false, // should not be visible - workaround for the subheader title to appear
                  },
                  {
                    title: 'Configuration',
                    page: 'secure/intune/app-management/configuration/templates',
                    translate: 'MENU.CONFIGURATION',
                    visible: false, // should not be visible - workaround for the subheader title to appear
                  },
                ],
              },
              {
                title: 'Onboarding',
                page: 'secure/intune/onboarding',
                translate: 'MENU.ONBOARDING',
                visible: true,
                submenu: [
                  {
                    title: 'Deployment Profiles',
                    page: 'secure/intune/onboarding/deployment-profiles',
                    translate: 'MENU.DEPLOYMENT_PROFILES',
                    visible: true,
                  },
                  {
                    title: 'Templates',
                    page: 'secure/intune/onboarding/templates',
                    translate: 'MENU.TEMPLATES',
                    visible: true,
                  },
                ],
              },
            ],
          },
          {
            title: 'Entra ID',
            icon: <img src="/media/icons/entra-id.svg" alt="entra id icon" />,
            page: 'secure/entra-id',
            translate: 'MENU.ENTRA_ID',
            visible: true,
            submenu: [
              {
                title: 'Groups',
                page: 'secure/entra-id/groups',
                translate: 'GENERAL.GROUPS',
                visible: true,
              },
              {
                title: 'Groups',
                page: 'secure/entra-id/groups-templates',
                translate: 'GENERAL.GROUPS',
                visible: false, // should not be visible - workaround for the subheader title to appear
              },
            ],
          },
        ],
      },
      {
        title: 'Engage',
        icon: 'engage',
        page: 'engage',
        translate: 'MENU.ENGAGE',
        visible: true,
        submenu: [
          {
            title: 'User Management',
            page: 'engage/user-management',
            translate: 'MENU.USER_MANAGEMENT',
            visible: true,
          },
          {
            title: 'Offboard Schedule',
            page: 'engage/action-log',
            translate: 'MENU.OFFBOARD_SCHEDULE',
            visible: true,
          },
          {
            title: 'Distribution Lists',
            page: 'engage/distribution-lists',
            translate: 'MENU.DISTRIBUTION_LISTS',
            visible: true,
          },
        ],
      },
      {
        title: 'Application Usage',
        icon: 'discover',
        page: 'discovery',
        translate: 'MENU.DISCOVER',
        visible: true,
        submenu: [
          {
            title: 'Application Usage',
            page: 'discovery',
            translate: 'MENU.APP_USAGE',
            visible: true,
          },
          {
            title: 'Discover Compliance',
            page: 'discover/risk',
            translate: 'MENU.DISCOVER_COMPLIANCE',
            visible: true,
          },
          {
            title: 'Agent',
            page: 'discover/data',
            translate: 'MENU.AGENT',
            visible: true,
          },
          {
            title: 'App Catalog',
            page: 'discover/applications',
            translate: 'SAASCONFIG.APP_CATALOG',
            visible: true,
          },
        ],
      },
      {
        title: 'Reports',
        icon: 'fas fa-chart-bar',
        page: 'reports',
        translate: 'MENU.REPORTS',
        visible: true,
        submenu: [
          {
            title: 'Multi-Factor Authentication Report',
            page: 'reports/mfa',
            translate: 'MENU.MFA_AUTHENTICATION',
            visible: false,
          },
          {
            title: 'Threat Report',
            page: 'reports/threats',
            translate: 'MENU.THREAT_REPORT',
            visible: false,
          },
          {
            title: 'Summary Report',
            page: 'reports/summary',
            translate: 'MENU.SUMMARY_REPORT',
            visible: false,
          },
          {
            title: 'License Report',
            page: 'reports/licensing',
            translate: 'MENU.LICENSE_REPORT',
            visible: false,
          },
          {
            title: 'License Report',
            page: 'reports/licensing-preview',
            translate: 'MENU.LICENSE_REPORT',
            visible: false,
            preview: true,
          },
          {
            title: 'Scheduled Reports',
            page: 'scheduled-reports',
            translate: 'MENU.SCHEDULED_REPORTS',
            visible: true,
          },
        ],
      },
      {
        title: 'Solutions',
        icon: 'fas fa-lightbulb',
        page: 'backup',
        translate: 'MENU.SOLUTIONS',
        submenu: [
          {
            title: 'Backup',
            page: 'backup',
            translate: 'MENU.BACKUP',
            visible: true,
          },
          {
            title: 'Security Training',
            page: 'security_training',
            translate: 'MENU.SECURITY_TRAINING',
            visible: true,
          },
        ],
        visible: true,
      },
      {
        title: 'Configuration',
        icon: 'flaticon2-settings',
        page: 'system-configuration',
        translate: 'MENU.CONFIGURATION',
        visible: true,
        submenu: [
          {
            title: 'Companies',
            page: 'companies',
            translate: 'MENU.COMPANIES',
            visible: true,
          },
          {
            title: 'Companies',
            page: 'company-collections',
            translate: 'MENU.COMPANIES',
            visible: false, // should not be visible - workaround for the subheader title to appear
          },
          {
            title: 'Employees',
            page: 'employees',
            translate: 'MENU.EMPLOYEES_AND_DEPARTMENTS',
            visible: true,
          },
          {
            title: 'Integrations',
            page: 'integrations',
            translate: 'MENU.INTEGRATIONS',
            visible: true,
          },
          {
            title: 'Account Mapping',
            page: 'integrations/duoaccountmapping',
            visible: false,
          },

          {
            title: 'Development',
            page: 'development',
            translate: 'MENU.DEVELOPMENT',
            visible: false,
          },
          {
            title: 'Mapping & Ticketing',
            page: 'integrations/:integrationId/connectwise',
            visible: false,
          },
          {
            title: 'Mapping & Ticketing',
            page: 'integrations/:integrationId/syncro',
            visible: false,
          },
          {
            title: 'Mapping & Ticketing',
            page: 'integrations/:integrationId/autotask',
            visible: false,
          },
          {
            title: 'Mapping & Ticketing',
            page: 'integrations/:integrationId/halo',
            visible: false,
          },
          {
            title: 'CSP Setup',
            beta: false,
            page: 'integrations/:integrationId/microsoft-csp',
            visible: false,
          },
        ],
      },
      {
        title: 'Audit Logs',
        root: true,
        icon: 'fa-regular fa-list-check',
        page: 'auditlogs',
        translate: 'MENU.AUDIT_LOGS',
        visible: true,
      },
      {
        title: 'Beta',
        icon: 'fa-regular fa-flask',
        page: 'beta',
        translate: 'MENU.BETA',
        visible: true,
        submenu: [
          {
            title: 'Compliance Audit',
            page: 'beta/compliance',
            translate: 'MENU.COMPLIANCE_AUDIT',
            visible: false,
            beta: true,
          },
          {
            title: 'Compliance Audit',
            page: 'beta/compliance/audit',
            translate: 'MENU.COMPLIANCE_AUDIT',
            visible: false, // should not be visible - workaround for the subheader title to appear
            beta: true,
          },
          {
            title: 'Compliance Audit',
            page: 'beta/compliance/assessments',
            translate: 'MENU.COMPLIANCE_AUDIT',
            visible: false, // should not be visible - workaround for the subheader title to appear
            beta: true,
          },
          {
            title: 'New Assessment',
            page: 'beta/compliance/assessment/create',
            translate: 'MENU.COMPLIANCE_AUDIT',
            visible: false, // should not be visible - workaround for the subheader title to appear
            beta: true,
          },
          {
            title: 'Edit Assessment',
            page: 'beta/compliance/assessment',
            translate: 'MENU.COMPLIANCE_AUDIT',
            visible: false, // should not be visible - workaround for the subheader title to appear
            beta: true,
          },
          {
            title: 'Copilot AI Readiness Report',
            icon: 'fa-regular fa-robot',
            page: 'beta/ai-readiness',
            translate: 'MENU.AI_READINESS_REPORT',
            visible: true,
          },
        ],
      },
      { separator: ' ' },
      {
        section: 'Management',
        translate: 'MENU.MANAGEMENT',
      },
      {
        title: 'License Center',
        root: true,
        icon: 'flaticon-medal',
        page: 'licenses',
        translate: 'MENU.LICENSE_CENTER',
        visible: true,
      },
      {
        title: 'System Users',
        root: true,
        icon: 'fa fa-user-group',
        page: 'users',
        translate: 'MENU.SYSTEM_USERS',
        visible: true,
      },
      {
        title: 'Billing',
        icon: 'flaticon-price-tag',
        page: 'billing',
        translate: 'MENU.BILLING',
        bullet: 'dot',
        visible: true,
      },
      {
        title: 'Support',
        icon: 'flaticon2-help',
        page: 'support',
        translate: 'MENU.SUPPORT',
        submenu: [
          {
            title: 'Open Ticket',
            page: 'open-ticket',
            translate: 'MENU.OPEN_TICKET',
            bullet: 'dot',
            visible: true,
          },
          {
            title: 'Chat with Support',
            page: 'chat',
            translate: 'MENU.SUPPORT_CHAT',
            bullet: 'dot',
            visible: true,
          },
          {
            title: 'Knowledge base',
            page: 'support',
            translate: 'MENU.KNOWLEDGE',
            bullet: 'dot',
            visible: true,
          },
          {
            title: 'Sales & Marketing Resources',
            page: 'marketing',
            translate: 'MENU.MARKETING',
            bullet: 'dot',
            visible: true,
          },
        ],
        visible: true,
      },
      {
        title: 'Profile',
        icon: 'flaticon2-user',
        page: 'user-profile',
        translate: 'MENU.PROFILE',
        bullet: 'dot',
        visible: false,
      },
      {
        title: 'Look and Feel',
        icon: 'flaticon2-browser',
        page: 'look-and-feel',
        translate: 'MENU.LOOKANDFEEL',
        bullet: 'dot',
        visible: true,
      },
    ],
  },
}

export const getMenuConfig = () => cloneDeep(menuConfig)
